// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--tipografia-familia:\"Montserrat\",sans-serif;--tipografia-tamanio:16px;--tipografia-codigo:monospace}.a11y-oscura .oscura-img-blanca img{filter:grayscale(1) brightness(100)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
